import script from "./BarraInform.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraInform.vue?vue&type=script&setup=true&lang=js"

import "./BarraInform.vue?vue&type=style&index=0&id=518d13ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518d13ac"]])

export default __exports__